import { Component, OnInit } from '@angular/core';
import { InvoiceMenu } from '../../_models/invoiceMenu';
import { Address } from '../../_models/address';
import { DataTableDirective } from 'angular-datatables';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import * as _ from "lodash";
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { Product } from '../../_models/product';
import { AccessSecurity } from '../../_models/accessSecurity';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-settings',
  templateUrl: './admin-settings.component.html',
  styleUrls: ['./admin-settings.component.css']
})
export class AdminSettingsComponent implements OnInit {
  ordersMainMenu: InvoiceMenu[] = [
    { displayName: "My Account", tabClicked: "myAccount", additional: "N" },
    { displayName: "Password Management", tabClicked: "passwordManagement", additional: "N" },
  ];
  tabClicked: string = "myAccount";

  currentPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  currentPwdError: string = '';
  newPwdError: string = '';
  confirmPwdError: string = '';
  invoicePreference: string = '';
  invoicePreferenceError: string = '';
  profileStep: number = 1;
  carriersList = [];
  carriersPreferencesList = [];
  userDrop2: any = 'myAccount';
  disableButton = true;
  account: any = {};

  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router, public accessSec: AccessSecurity) {
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      let index = this.ordersMainMenu.findIndex((d) => d.tabClicked === this.g.pageTab);
      if (index == -1) {
        for (let ol of this.ordersMainMenu) {
          if (ol.tabClicked === this.g.pageTab) {
            this.switchPosition(ol);
          }
        }
      }
    } else {
      this.tabClicked = "myAccount";
      this.populateTabData("myAccount");
    }

  }

  ngOnInit() {
  }


  populateTabData(triggered) {
    this.tabClicked = triggered;
    if (this.tabClicked === 'myAccount') {
      this.api.getAdminDetail("1", "1").subscribe((data: any = []) => {
        this.g.loaderDisplay = "";
        this.account = data;
      }, err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
    }
  }

  switchPosition(om) {
    let index = this.ordersMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.ordersMainMenu[4].displayName) {
      this.ordersMainMenu[4].additional = 'Y';
    }
    var tmp = 5;
    for (let o of this.ordersMainMenu) {
      if (tmp < this.ordersMainMenu.length) {
        if (om.displayName !== this.ordersMainMenu[tmp].displayName) {
          this.ordersMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }

  typeConfirmPwd() {
    this.confirmPwdError = '';
    if (!this.confirmPassword) {
      this.confirmPwdError = 'Please enter confirm password';
    } else if (this.confirmPassword !== this.newPassword) {
      this.confirmPwdError = 'Password does not match';
    }
  }

  typeNewPwd() {
    this.newPwdError = '';
    if (!this.newPassword) {
      this.newPwdError = 'Please enter new password';
    } else if (this.newPassword.length <= 5) {
      this.newPwdError = 'Password must be minimum 6 characters';
    }
  }

  typeCurrentPwd() {
    this.currentPwdError = '';
    if (!this.currentPassword) {
      this.currentPwdError = 'Please enter current password';
    }
  }

  submitChangePassword() {
    this.typeNewPwd();
    this.typeCurrentPwd();
    this.typeConfirmPwd();
    if (this.confirmPwdError != "" || this.newPwdError != "" || this.currentPwdError != "") {
      return false;
    }
    let request = {
      "currentPassword": this.currentPassword,
      "newPassword": this.newPassword
    };
    this.g.loaderDisplay = "display";
    this.api.changePassword(request).subscribe((data: any = []) => {
      if (data['code'] == 200) {
        this.g.loaderDisplay = "";
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.alertService.success('Password', 'Changed Successfully');
      } else {
        this.alertService.error('Error', data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";
      console.log(err);
      this.alertService.error('Error', 'Change Password Failed, please re-try.');
    });
  }
}
